import React from "react";
import LoginModal from "./LoginModal";

const LoginPage = () => {
  return (
    <div style={{ backgroundColor: '#449AEF' }} className="w-screen h-screen flex items-center justify-center">
      <LoginModal alwaysOpen={true} />  
    </div>
  );
};

export default LoginPage;
